'use client';

import { useFormatLabel } from './useFormatLabel';

interface IDefaultLabelProps {
  cx: number;
  cy: number;
  midAngle: number;
  innerRadius: number;
  outerRadius: number;
  name: string;
  value: number;
  percent: number;
  smallValueThreshold: number;
}

/**
 * -----------------------------------------------------------------------------
 * Custom component to display the default label.
 */
export function DefaultLabel({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  name,
  value,
  percent,
  smallValueThreshold,
}: IDefaultLabelProps) {
  const RADIAN = Math.PI / 180;

  // Format label text - show just percentage for large values, full format for small
  const formatLabel = useFormatLabel(percent, smallValueThreshold);

  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      dominantBaseline="central"
      fill="currentColor"
      fontSize={13}
      fontWeight={500}
      pointerEvents="none"
      textAnchor={x > cx ? 'start' : 'end'}
      x={x}
      y={y}
    >
      {formatLabel(name, value)}
    </text>
  );
}
